import { BaseRequest } from 'src/app/tools/models/dtos/base-request';import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { Brand } from '../../entities/control-tables/brand';


export class BrandRequest extends BaseRequest {

    brand : Brand

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.brand = new Brand();
  }
}